export default {
  setGoodGives(state, payload) {
    state.goodGives = payload
  },
  updateGoodGives(state, payload) {
    state.goodGives = state.goodGives.concat(payload)
  },
  setGoodGiveFilters(state, payload) {
    state.goodGiveFilters = payload
  },
  setGoodGiveStatuses(state, payload) {
    state.goodGiveStatuses = payload
  },
  setGoodGiveSearched(state, payload) {
    state.goodGiveSearched = payload
  },
  setGoodGive(state, payload) {
    state.goodGive = payload
  },
  setGoodGiveAvailable(state, payload) {
    state.goodGiveAvailable = payload
  },
  setGoodGiveParam(state, obj) {
    if (state.goodGive) {
      state.goodGive = { ...state.goodGive, ...obj }
    }
  },
  changeGoodGive(state, payload) {
    state.goodGive = { ...payload }

    delete payload.employer
    delete payload.history
    delete payload.unit

    for (let i = 0; i < state.goodGives.length; i++) {
      if (state.goodGives[i].id === payload.id) {
        state.goodGives.splice(i, 1, payload)
        break
      }
    }
  },
}
